import dayjs from 'dayjs';

import { DateInput } from '../types';

export const isSameDate = ({ dateA, dateB, unit = 'day' }: { dateA: DateInput; dateB: DateInput; unit?: 'day' }) =>
  dayjs(dateA).isSame(dateB, unit);
